<template>
  <div>
    <!-- 화면 타이틀 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title word-type pb-5">
        <icon-policy :width="22" :height="22" />
        개인정보처리방침
      </v-col>
    </v-row>

    <!-- 개인정보처리방침 내용 -->
    <v-row class="ma-0 overflow-y-auto">
      <v-col cols="12" class="pa-0">
        <privacy-policy />
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* 개인정보처리방침 */
import IconPolicy from '@/assets/customIcon/IconPolicy.vue';
import PrivacyPolicy from '@/components/settings/policy/PrivacyPolicy.vue';

export default {
  computed: {},
  components: { IconPolicy, PrivacyPolicy },
};
</script>

<style></style>
